import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getBasicImageListApi = (params) => {
  return httpService({
    url: contextPath + '/system/docker/info',
    method: 'get',
    params
  })
}

export const getAllBasicImageNotOpenListApi = (params) => {
  return httpService({
    url: contextPath + '/system/docker/list/getNotOpen',
    method: 'get',
    params
  })
}

export const createBasicImageApi = (data) => {
  return httpService({
    url: contextPath + '/system/docker/item',
    method: 'post',
    data
  })
}

export const modifyBasicImageApi = (data) => {
  return httpService({
    url: contextPath + '/system/docker/item',
    method: 'put',
    data
  })
}

export const modifyBasicImageStatusApi = (params) => {
  return httpService({
    url: contextPath + '/system/docker/item/changeDockerStatus',
    method: 'put',
    params
  })
}

export const deleteBasicImageApi = (params) => {
  return httpService({
    url: contextPath + '/system/docker/item',
    method: 'delete',
    params
  })
}
